<dx-drawer class="main-content" [openedStateMode]="selectedOpenMode" [position]="selectedPosition"
           [revealMode]="selectedRevealMode" template="template" [(opened)]="isDrawerOpen" [height]="'100%'"
           [closeOnOutsideClick]="true">
  <div *dxTemplate="let data of 'template'" style="width: 260px; height: 100vh">
    <div class='dashboard-title'>

      <img width="160px" src="/assets/images/logo.png"/>
    </div>
    <div class="user-section">
      <div class="user">
        <img class="user-avatar" [src]="profileImage"/>
        <div class="user-info">
          <div class="user-name">{{ currentUser.displayName }}</div>
          <div class="user-role">Administrator (v 2.0.0)</div>
          <div class="user-logout" (click)="onLogout()">Logout</div>
        </div>
      </div>
    </div>
    <dx-list class="panel-list dx-theme-custom main-navigation"
             [dataSource]="navigation"
             [hoverStateEnabled]="true"
             [activeStateEnabled]="false"
             [focusStateEnabled]="false"
             [selectionMode]="'single'"
             [selectedItemKeys]="selectedMenu"
             keyExpr="id"
             (onItemClick)="onMenuItemClick($event)"
    >
      <div *dxTemplate="let item of 'item'">
        <div [ngClass]="{'parent-item': item.items, 'child-item': !item.items, 'active-parent': item.expanded}">
          <div class="menu-item">
            <i *ngIf="item.icon && item.icon !== 'pool' && item.icon !== 'chart' && item.icon !== 'home'" class="dx-icon-{{item.icon}}"></i>
            <i *ngIf="item.icon === 'pool'" class="material-icons">pool</i>
            <img *ngIf="item.icon === 'home'" class="logo-icon" src="/assets/images/homepage.png" style="height: 15px; width: 15px; margin-right: 10px;"/>
            <i *ngIf="item.icon === 'chart'" class="material-icons">assessment</i>
            <span>{{ item.text }}</span>
          </div>
          <div *ngIf="item.items && item.expanded" class="child-items">
            <div *ngFor="let childItem of item.items"
                 class="menu-item child-item"
                 [ngClass]="{'active-child': isSelected(childItem)}"
                 (click)="navigateToRoute(childItem, $event)"
                 (mousedown)="$event.stopPropagation()">
              <span>{{ childItem.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </dx-list>
  </div>
  <div>
    <app-nav-bar [drawerButtonOption]="drawerButtonOption"></app-nav-bar>
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
    <!--    <app-footer></app-footer>-->
  </div>
</dx-drawer>

<app-notification></app-notification>
